import React, { Component } from 'react'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
// import ReactMarkdown from 'react-markdown'
import { connect } from 'react-redux'
import { compose } from 'redux'
import Scroll from 'react-scroll'
import queryString from 'query-string'

import WebTracker from '@supersoccer/web-tracker'
import LazyLoad from '@components/common/Lazyload'
import history from '@source/history'
import { coronaImageDesktop, coronaImageMobile } from '@global/imageUrl'
import BodyClassName from 'react-body-classname'

// import coronaGuardDesktop from '../../global/assets-global/images/corona-guard-d.png'
// import coronaGuardMobile from '../../global/assets-global/images/corona-guard-m.png'
import CoronaTerms from './CoronaTerms'
import s from './CoronaPage.css'

let Link = Scroll.Link
let Element = Scroll.Element
let stickyBtn, stickyBtnOffsetTop, stickyBtnHeight
class CoronaPage extends Component {
  state = {
    isSticky: false,
  }

  componentDidMount() {
    const {
      user,
      configParams,
      isPage,
      runtime: { isMobile },
    } = this.props
    if (!isPage) {
      const isCoronaPageEnabled = configParams && configParams.data && configParams.data.corona_page_enabled
      const pubsubConfig =
        configParams && configParams.data && configParams.data.pubsub ? configParams.data.pubsub : null

      if (isCoronaPageEnabled) {
        const pubsubUrl =
          configParams && configParams.data && configParams.data.pubsub_url
            ? configParams.data.pubsub_url
            : 'http://pubsub.com'
        const getEnv = window.App.env === 'production' ? 'production' : 'staging'
        const payload = {
          window,
          userData: user,
          linkRedirectUrl: '/corona-popup',
          document: document,
          event: 'event_pages',
        }

        WebTracker.trackEvent({ data: payload, pubsubConfig })
      }
    }

    if (isMobile) {
      if (__BROWSER__) {
        stickyBtn = document.getElementById('sticky_button')
        stickyBtnOffsetTop = stickyBtn && stickyBtn.offsetTop
        stickyBtnHeight = stickyBtn && stickyBtn.clientHeight
        // console.log("sticky_button offsettop", stickyBtnOffsetTop)
        window.addEventListener('scroll', this.handleScroll, true)
        stickyBtn && stickyBtn.classList.add('sticky')
      }
    }
  }

  donationLink = () => {
    const {
      runtime: { isMobile },
      isPage,
      backToApps,
    } = this.props
    if (this.props.hasCoronaPage) {
      this.props.updateCoronaPage()
    }

    let utmMedium = isPage ? 'corona-page' : 'corona-popup'

    if (backToApps) {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage('subscribe')
      }
    } else {
      history.push(`/accounts/profile?tab=subscriptionPackage&utm_source=molatv&utm_medium=${utmMedium}`)
    }
  }

  closeApp = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage('close')
    }
  }

  nextTimeLink = () => {
    const {
      runtime: { isMobile },
      goBackLink,
      isPage,
      backToApps,
      configParams,
    } = this.props
    if (isPage && goBackLink) {
      if (backToApps) {
        this.closeApp()
      } else {
        goBackLink()
      }
    } else {
      // popup
      // if (isMobile) {
      // const isApple = /iPad|iPhone|iPod/.test(navigator.userAgent)
      // let urlParams = queryString.parse(window.location.search)
      // const videoId = urlParams.v ? urlParams.v : ''
      // const source = urlParams.utm_source ? urlParams.utm_source : 'redirect-from-browser'
      // const medium = urlParams.utm_medium ? urlParams.utm_medium : ''
      // const campaign = urlParams.utm_campaign ? urlParams.utm_campaign : ''

      // if (isApple) {
      //   if (videoId) {
      //     const appStore = configParams && configParams.data && configParams.data.store_url ? configParams.data.ios_store_url : ''
      //     document.location = `molaapp://mola.tv/watch?v=${videoId}&utm_source=${source}&utm_medium=${medium}&utm_campaign=${campaign}`
      //     setTimeout(function () {
      //       document.location = appStore
      //     }, 250)
      //   } else {
      //     document.location = appStore
      //   }

      // } else {
      //   if (videoId) {
      //     const playStore = configParams && configParams.data && configParams.data.store_url ? configParams.data.store_url : ''
      //     document.location = `intent://mola.tv/watch?v=${videoId}&utm_source=${source}&utm_medium=${medium}&utm_campaign=${campaign}/#Intent;scheme=molaapp;package=tv.mola.app;S.browser_fallback_url=${playStore};end`
      //   } else {
      //     document.location = playStore
      //   }
      // }

      this.closeApp()
      // } else {
      if (this.props.hasCoronaPage) {
        this.props.updateCoronaPage()
      }
      // }
    }
  }

  handleScroll = () => {
    // console.log("window.pageYOffset", window.pageYOffset)
    // console.log("clientheight", document.body.clientHeight)
    // console.log("btn height", document.getElementById("sticky_button").clientHeight)

    const { backToApps } = this.props
    const pageHeight = document.body.clientHeight,
      offsetBrowseBar = 60,
      offsetHeaderNav = backToApps ? 0 : 110 //(header + bottom navbar)

    // console.log("AA:", window.pageYOffset + (pageHeight - offsetBrowseBar - offsetHeaderNav - stickyBtnHeight))
    // console.log("stickyBtnOffsetTop", stickyBtnOffsetTop)
    let isSticky = true
    if (window.pageYOffset + offsetBrowseBar + (pageHeight - offsetHeaderNav - stickyBtnHeight) >= stickyBtnOffsetTop) {
      //not-sticky
      stickyBtn && stickyBtn.classList.remove('sticky')
    } else {
      stickyBtn && stickyBtn.classList.add('sticky')
    }
  }

  render() {
    const {
      runtime: { isMobile, noHeader, hasCoronaPage },
      isPage,
      configParams,
      backToApps,
    } = this.props
    const { isSticky } = this.state
    const isCoronaPageEnabled =
      isPage || (configParams && configParams.data && configParams.data.corona_page_enabled && hasCoronaPage)
    const allowPageScroll = isPage && !backToApps
    const donationButtonEnabled = configParams && configParams.data && configParams.data.corona_donation_button_enabled
    return (
      <>
        {allowPageScroll && <BodyClassName className={s.page_scroll} />}
        {isCoronaPageEnabled && (
          <LazyLoad containerClassName={s.cp__wrapper}>
            <div className={s.bg__container}></div>
            <>
              <div className={s.image__container__background}>
                <div className={s.image__container}>
                  <img className={s.corona__campaign__image} src={coronaImageDesktop} alt="corona campaign image" />
                </div>
              </div>
              <div className={s.description__container__background}>
                <div className={s.description__container}>
                  <div className={s.first__description}>
                    <p>
                      Mari bersama menyumbang ke penanggulangan wabah virus Corona/Covid-19 sambil menikmati beragam
                      acara hiburan unik Mola TV.
                    </p>
                  </div>
                  <div className={s.second__description}>
                    <p>
                      Caranya cukup dengan berlangganan paket Corona Care Mola TV. Mola TV akan menggandakan kontribusi
                      Anda dan menyalurkannya kepada BNPP & PMI untuk membantu perjuangan melawan virus Corona/Covid-19.
                    </p>
                  </div>
                  <div className={s.third__description}>
                    <div className={s.third__description__paragraph__container}>
                      <p className={s.third__description__paragraph}>
                        Bosan nonton acara yang itu-itu saja? Saksikan<span> Musafir Malam </span>
                        yang mengulik sisi lain tokoh ternama Indonesia,
                        <span> Dinner With…,</span> yang membawa Anda makan malam bersama host
                        <strong> Sophia Latjuba</strong>, <strong> Julie Estelle</strong>, dan{' '}
                        <strong> Dian Sastro</strong>, serta <span> Masakan Rumah</span> yang melihat rahasia masakan
                        Indonesia bersama
                        <strong> Happy Salma</strong> dan program <strong> Kreasi Mola</strong> lainnya.
                      </p>
                      <p className={s.third__description__paragraph}>
                        {' '}
                        Bagi Anda pecinta sepakbola saksikan serial
                        <span> Dream Chasers - Garuda Select</span> yang mengikuti perjuangan{' '}
                        <strong> 24 pemain muda terbaik Indonesia</strong> mengejar impian mereka.
                      </p>
                      <p className={s.third__description__paragraph}>
                        Kehabisan ide menemani anak di rumah? Temani si kecil mengenal Dinosaurus di acara
                        <span> Dino Dan</span>, perkaya ilmu sains sambil bermain lewat acara <span> Look Kool</span>,
                        dan banyak lagi acara edutainment yang bisa diperoleh dengan berlangganan Paket Corona Care Mola
                        TV.
                      </p>
                    </div>
                    <div className={s.confirmation__description__container}>
                      {donationButtonEnabled && (
                        <div className={s.confirmation__description__container__background}>
                          <p className={s.confirmation__description}>
                            Pilih sendiri nilai Paket langganan Corona Care Mola TV Anda.
                          </p>
                          <p className={s.confirmation__description}>Bersama, kita bisa melawan wabah virus Corona.</p>
                          {!isMobile && (
                            <>
                              <button className={s.blue__button} onClick={() => this.donationLink()}>
                                Berikan Sumbangan
                              </button>
                              <button className={s.black__button} onClick={() => this.nextTimeLink()}>
                                Lain Waktu
                              </button>
                              <div className={s.link__container}>
                                <Link
                                  to={'terms'}
                                  spy={false}
                                  hashSpy={false}
                                  smooth={'easeInOutExpo'}
                                  duration={300}
                                  offset={-30}
                                  className={s.terms__link}
                                >
                                  {'Syarat & Ketentuan'}
                                </Link>

                                <Link
                                  to={'faq'}
                                  spy={false}
                                  hashSpy={false}
                                  smooth={'easeInOutExpo'}
                                  duration={300}
                                  offset={-30}
                                  className={s.terms__link}
                                >
                                  FAQ
                                </Link>
                              </div>
                              {/* <a className={s.terms__link} href="/terms/corona-care">{`Syarat & Ketentuan`}</a>
                        <a className={s.terms__link} href="/terms/corona-care">FAQ</a> */}
                            </>
                          )}
                        </div>
                      )}
                      {!donationButtonEnabled && (
                        <div className={s.confirmation__description__container__background}>
                          <p className={s.confirmation__description}>Paket Donasi Corona Care sudah tidak tersedia.</p>
                          <p className={s.confirmation__description}>
                            Anda masih bisa menikmati paket lainnya melalui tombol di bawah ini.
                          </p>
                          {!isMobile && (
                            <>
                              <button className={s.blue__button} onClick={() => this.donationLink()}>
                                Lihat Paket Lainnya
                              </button>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* mobile button */}
              {isMobile && donationButtonEnabled && (
                <>
                  <div className={s.confirmation__button__container__background} id={'sticky_button'}>
                    <div className={s.confirmation__button__container}>
                      <button className={s.blue__button__sticky} onClick={() => this.donationLink()}>
                        Berikan Sumbangan
                      </button>
                      <button className={s.black__button__sticky} onClick={() => this.nextTimeLink()}>
                        Lain Waktu
                      </button>
                    </div>
                    {/* <a className={s.terms__link} href="/terms/corona-care">{`Syarat & Ketentuan`}</a>
                <a className={s.terms__link} href="/terms/corona-care">FAQ</a> */}
                    <div className={s.link__container}>
                      <Link
                        to={'terms'}
                        spy={false}
                        hashSpy={false}
                        smooth={'easeInOutExpo'}
                        duration={300}
                        offset={50}
                        className={s.terms__link}
                      >
                        {'Syarat & Ketentuan'}
                      </Link>

                      <Link
                        to={'faq'}
                        spy={false}
                        hashSpy={false}
                        smooth={'easeInOutExpo'}
                        duration={300}
                        offset={30}
                        className={s.terms__link}
                      >
                        FAQ
                      </Link>
                    </div>
                  </div>
                </>
              )}
              {isMobile && !donationButtonEnabled && (
                <>
                  <div className={s.confirmation__button__container__background} id={'sticky_button'}>
                    <div className={s.confirmation__button__container__disabled}>
                      <button className={s.blue__button__sticky} onClick={() => this.donationLink()}>
                        Lihat Paket Lainnya
                      </button>
                    </div>
                  </div>
                </>
              )}
              <CoronaTerms backToApps={backToApps} isMobile={isMobile} history={history} />
            </>
          </LazyLoad>
        )}
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    runtime: { ...state.runtime },
    configParams: { ...state.configParams },
    user: { ...state.user },
  }
}

export default compose(withStyles(s), connect(mapStateToProps, null))(CoronaPage)
